import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Report } from '../../report/models/report.model';
import { Provider } from '../../provider/provider.model';
import { IRteListButtonItem } from 'rte-library';


@Component({
  selector: 'app-report-info',
  templateUrl: './report-info.component.html',
  styleUrls: ['./report-info.component.scss']
})
export class ReportInfoComponent implements OnInit {

  //#region Inputs
  @Output() onViewReport : EventEmitter<any> = new EventEmitter<any>();

  //#endregion

  //#region properties

  //#endregion

  constructor() { }

  ngOnInit() {
  }

}
